export default __webpack_public_path__ + "static/media/advance-right.b4f97e5e.png";